/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestLogoutRequest
 */
export interface RequestLogoutRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestLogoutRequest
     */
    loginHistoryId?: number;
}

/**
 * Check if a given object implements the RequestLogoutRequest interface.
 */
export function instanceOfRequestLogoutRequest(value: object): value is RequestLogoutRequest {
    return true;
}

export function RequestLogoutRequestFromJSON(json: any): RequestLogoutRequest {
    return RequestLogoutRequestFromJSONTyped(json, false);
}

export function RequestLogoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestLogoutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'loginHistoryId': json['loginHistoryId'] == null ? undefined : json['loginHistoryId'],
    };
}

export function RequestLogoutRequestToJSON(json: any): RequestLogoutRequest {
    return RequestLogoutRequestToJSONTyped(json, false);
}

export function RequestLogoutRequestToJSONTyped(value?: RequestLogoutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loginHistoryId': value['loginHistoryId'],
    };
}

